export default __webpack_public_path__ + "pdf/USC-Bridge-small.d28fbb0.pdf";